export default function BookingCTA() {
  return (
    <section className="py-20 md:py-28 bg-[#0e0a07]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
        <div
          className="relative rounded-2xl md:rounded-3xl overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #1a1008 0%, #2a1a08 50%, #1a1008 100%)',
          }}
        >
          {/* Gold border */}
          <div className="absolute inset-0 rounded-2xl md:rounded-3xl border border-[#c9a84c]/25 pointer-events-none" aria-hidden="true" />

          {/* Decorative glow */}
          <div className="absolute top-0 right-0 w-64 md:w-96 h-64 md:h-96 bg-[#c9a84c]/8 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" aria-hidden="true" />
          <div className="absolute bottom-0 left-0 w-48 md:w-64 h-48 md:h-64 bg-[#c9a84c]/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" aria-hidden="true" />

          {/* Logo watermark */}
          <img
            src="https://equi-as.no/img/LogoTransparent.png"
            alt=""
            className="absolute right-10 top-1/2 -translate-y-1/2 w-48 md:w-64 opacity-5 object-contain pointer-events-none select-none hidden lg:block"
            aria-hidden="true"
          />

          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-10 px-6 sm:px-10 md:px-16 py-12 md:py-16">
            <div className="text-center lg:text-left">
              <p className="text-[#c9a84c] text-xs tracking-[0.25em] uppercase font-medium mb-3 md:mb-4">Klar for en forandring?</p>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-3 md:mb-4">
                Bestill din time
                <br />
                <span className="text-[#c9a84c]">i dag</span>
              </h2>
              <p className="text-white/50 text-sm md:text-base max-w-md leading-relaxed mx-auto lg:mx-0">
                Kom innom vår koselige klinikk i Moelv og opplev profesjonelle behandlinger tilpasset akkurat deg. Vi gleder oss til å ta imot deg!
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 flex-shrink-0 w-full sm:w-auto">
              <button
                onClick={() => window.open('https://system.easypractice.net/book/equi#choose-where', '_blank')}
                className="w-full sm:w-auto px-8 md:px-10 py-4 bg-[#c9a84c] text-[#0e0a07] font-semibold rounded-full hover:bg-[#e0c06a] active:scale-95 transition-all duration-300 text-sm tracking-wide whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                <i className="ri-calendar-check-line" />
                <span>Bestill time online</span>
              </button>
              <a
                href="tel:+4746884700"
                className="w-full sm:w-auto px-8 md:px-10 py-4 border border-white/20 text-white rounded-full hover:border-[#c9a84c]/50 hover:text-[#c9a84c] active:scale-95 transition-all duration-300 text-sm tracking-wide whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line" />
                <span>Ring oss</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}